import {React, styled} from 'common'
import RawMenuItem from '@mui/material/MenuItem'
import {ListItemIcon} from '@mui/material'

const MenuItem = ({title, icon, onClick}) => {
    return (
        <RawMenuItem onClick={onClick}>
            <ListItemIcon>{icon}</ListItemIcon>
            <Title>{title}</Title>
        </RawMenuItem>
    )
}

export default MenuItem

const Title = styled.span``
